import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExpanderGroupService } from 'src/app/components/expander/expander-group.service';
import { ItemButtonComponent } from 'src/app/components/item-button/item-button.component';
import { ItemComponent } from 'src/app/components/item/item.component';
import { DocumentViewModel } from 'src/app/services/document-instance-build.service';

@Component({
	selector: 'app-document-section-expand-buttons',
	templateUrl: './document-section-expand-buttons.component.html',
	styleUrls: ['./document-section-expand-buttons.component.scss'],
	imports: [ItemComponent, ItemButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentSectionExpandButtonsComponent {

	@Input() viewModel!: DocumentViewModel;

	constructor(private expanderGroupService: ExpanderGroupService) {
	}

	expandCollapseSections(expand: boolean) {
		this.expanderGroupService.expandCollapseAll(expand);
	}
}